export const SHOPIFY_PREFIX = 'SHOPIFY_';

export const SHOPIFY_MODE = {
  SHOPIFY_ORDERS: `${SHOPIFY_PREFIX}ORDERS`,
  SHOPIFY_BOOK_MULTIPLE: `${SHOPIFY_PREFIX}BOOK_MULTIPLE`,
  SHOPIFY_BOOK_MSD: `${SHOPIFY_PREFIX}BOOK_MSD`,
};
